<template>
<div class="treeLayout">
    <div class="leftSlider">
        <el-menu v-bind="$attrs" v-on="$listeners" style="height: 100%" @select="select" :default-active="value">
            <el-submenu v-for="menu in treeData" :key="menu.id" :index="menu.id">
                <template slot="title">
                    <span>{{menu.label}}</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item v-for="subMenu in menu.children" :key="subMenu.id" :index="subMenu.id">{{subMenu.label}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
    <div class="p10 df rightContent">
        <slot name="default"></slot>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    props: {
        value: {
            type: String | Number,
            default: ""
        },
        treeData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        getSelect(list, id) {
            for (const listElement of list) {
                if (listElement.id === id) {
                    return listElement;
                }
                if (listElement.children) {
                    let result = this.getSelect(listElement.children, id);
                    if (result) {
                        return result;
                    }
                }
            }
        },
        select(id) {
            let result = this.getSelect(this.treeData, id);
            if (result && !result.disabled) {
                this.$emit("input", id);
                this.$emit("menu-click", result);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.treeLayout {
    height: 100%;
    display: flex;
    align-items: stretch;

    .leftSlider {
        width: 220px;
        flex-grow: 0;
        flex-shrink: 0;
        padding: 0px 10px;
        margin: 10px 0px;
        overflow: auto;
    }

    .rightContent {
        width: calc(100% - 230px);
    }
}

/deep/ .el-menu-item-group__title {
    display: none;
}
/deep/ .el-submenu__title {
  overflow: hidden;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/treeLayout/treeLayout.vue